import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-ias-footer',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './ias-footer.component.html',
  styleUrls: ['./ias-footer.component.scss']
})
export class IasFooterComponent {
  finalDate: string;

  constructor() {
    const today = new Date();
    const formattedDate = today.toLocaleDateString('en-GB'); // dd/MM/yyyy
    this.finalDate = formattedDate.replace(/\//g, '-');      // dd-MM-yyyy
  }
}
